import { Button, Grid, GridItem, Text, VerticalSpacer } from "@innovationnorway/lighthouse-components";
import React from "react";
import "./infoCard.scss";
import InfoLine from "./infoLine/infoLine";

export interface InfoLineProps {
  textKey: string;
  value?: string | number;
  dateValue?: Date;
  longKey?: boolean;
  id: string;
}

interface InfoCardProps {
  heading?: string;
  infoLines?: InfoLineProps[];
  buttonText?: string;
  buttonOnClick?: () => void;
  dummyText?: string;
  modalChildren?: React.ReactNode;
  buttonDisabled?: boolean;
}

const InfoCard = ({
  heading,
  infoLines,
  buttonText,
  buttonOnClick,
  dummyText,
  modalChildren,
  buttonDisabled
}: InfoCardProps) => {
  return (
    <>
      <div className="largeCard">
        <div className="cards">
          <div className="cardContainer">
            <Text variant="lead2">{heading}</Text>
            {infoLines?.map((infoLine) => (
              <InfoLine
                key={infoLine.id}
                textKey={infoLine.textKey}
                value={infoLine.value}
                dateValue={infoLine.dateValue}
                longKey={infoLine.longKey}
              />
            ))}
            {dummyText && (
              <>
                <VerticalSpacer size="s" />
                <Text className="dummyText">{dummyText}</Text>
              </>
            )}
            <VerticalSpacer size="m" />
            {/* TODO: Temporary fix for disabling button */}
            {!buttonDisabled && (
              <Grid style={{ maxWidth: "100%" }}>
                <GridItem style={{ justifySelf: "end" }} spanLarge={12} spanMedium={12} spanSmall={4}>
                  <Button
                    variant="primary"
                    onClick={buttonOnClick}
                    icon="arrow-right"
                    iconPosition="right"
                    disabled={buttonDisabled}
                  >
                    {buttonText}
                  </Button>
                </GridItem>
              </Grid>
            )}
          </div>
        </div>
      </div>
      {modalChildren}
    </>
  );
};

export default InfoCard;
